// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";
import axios from "./axios";
import i18n from "./i18n";
import promise from 'es6-promise'
import 'babel-polyfill'
import mock from "./mock";

import toast from "@/components/toast";
import wsDialog from "@/components/wsDialog";


promise.polyfill()
if (process.env.NODE_ENV == "production") {
  Vue.prototype.$token = window.global.token;
  Vue.prototype.$reqUrl = window.global.reqUrl;
  Vue.prototype.$userData = window.global.userData;
  Vue.prototype.$search_client = window.global.search_client;
  Vue.prototype.$graph_client = window.global.graph_client;
} else {
  Vue.prototype.$reqUrl = mock.reqUrl;
  Vue.prototype.$userData = mock.userData;
  Vue.prototype.$search_client = mock.search_client;
  Vue.prototype.$graph_client = mock.graph_client;
}

const dialogConstruct = Vue.extend(wsDialog);
const toastConstruct = Vue.extend(toast);
function dialog(options) {
  const instance = new dialogConstruct();
  if (typeof options == "object") {
    Object.assign(instance, options);
  }
  document.body.appendChild(instance.$mount().$el);
}
function goToast(options) {
  const toastInstance = new toastConstruct();
  if (typeof options == "object") {
    Object.assign(toastInstance, options);
  }
  let toastEl = toastInstance.$mount().$el;
  document.getElementById("main-part").appendChild(toastEl);
}

Vue.prototype.$fire = new Vue();
Vue.prototype.$http = axios;
Vue.prototype.$curPath = function () {
  return this.$route.path.split("/").slice(1);
};

Vue.prototype.$toast = goToast;
Vue.prototype.$dialog = dialog;
Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  i18n,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js